import React from 'react';
import { IIconProps } from './utils';

export const Add = ({
  fill = 'currentColor',
  height = 30,
  width = 30,
  ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M15.0001 14.9998H22.4999M15.0001 14.9998H7.50024M15.0001 14.9998V7.5M15.0001 14.9998V22.4997"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.99994"
    />
  </svg>
);
